import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";
import { isPosthogReady } from "./init";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (!isPosthogReady()) return;
    posthog.capture("$pageview", {
      $current_url: window.location.href,
    });
  }, [location.pathname, location.search]);
}
